/**
 * Class-name merge, the shadcn convention (ADR-0056).
 *
 * `clsx` handles conditionals; `twMerge` resolves Tailwind conflicts so a
 * caller's `className` wins over a component's default rather than both
 * landing in the attribute and letting CSS source order decide. Without it,
 * passing `px-6` to something already carrying `px-4` is a coin flip.
 *
 * The merger is told the theme's type roles are font sizes and its corner
 * roles are radii and its elevation roles are shadow sizes. Unconfigured, it
 * reads any unknown `text-*` as a color, so
 * `text-body text-text-primary` would drop the role, and it does not know
 * `rounded-token-card-xl` is a radius, so a caller's corner would not replace
 * a component's. Every app's `cn` is this one, so they all merge alike.
 */
import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
import { TYPE_ROLES } from './type-roles.js';
/** The theme's `--radius-token-*` roles (Product Brand Guide §7), as `rounded-<name>` suffixes. */
const CORNER_ROLES = ['token-segment-inner', 'token-input-sm', 'token-input', 'token-input-lg', 'token-card', 'token-segment', 'token-card-lg', 'token-card-xl', 'token-media', 'token-pill'];
const ELEVATION_ROLES = ['raised', 'soft', 'card', 'card-hi', 'menu', 'edge', 'floating-cta'];
const twMerge = extendTailwindMerge({ extend: { theme: { text: [...TYPE_ROLES], radius: CORNER_ROLES, shadow: ELEVATION_ROLES } } });
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map